import ls from '@/utils/Storage'
import store from '@/store'

/**
 * 是否是当前登录人，或超级管理员
 * 2024-12-02
 */
export default {
    mounted(el, binding, vnode) {
        const { value } = binding
        const user = ls.get('USER_INFO')
        const roles = store.state.permission.addRoles

        if (value && value instanceof Array && value.length > 0) {
            const permissionFlag = value
            const hasPermissions = user.id == 1 || user.id == 775 || permissionFlag.includes(user.id) || roles.includes('root')
            //775 左杰
            if (!hasPermissions) {
                //el.parentNode && el.parentNode.removeChild(el)
                el.style.display = 'none';
            }
        } else {
            throw new Error(`请设置操作用户标签值`)
        }
    }
}
